
class Communicate
{
  // ---------------------------------------------------------------------------------------------------------
	// --	Communicate
	// ---------------------------------------------------------------------------------------------------------

  constructor()
  {
    // console.log('Communicate')

    //DOM参照
    this.slider = $('.sc-communicate__slider')
    this.list = $('.sc-communicate__slider-list')

    //アイテムの数
    this.itemNum = $(".sc-communicate__slider-list-item").length

    //スクロール量
    const item1 = $(".sc-communicate__slider-list-item").eq(0)
    const item2 = $(".sc-communicate__slider-list-item").eq(1)
    const itemW = item2.offset().left - item1.offset().left
    // console.log('itemW:' + itemW)
    this.scrollMax = itemW * this.itemNum

    //スクロール量
    this.scrollX = 0
    this.scrollSpeed = 1
 
    //リストを複製
    let cloneObjects =  $(".sc-communicate__slider-list-item").clone()
    for(let i=0; i<2; i++)
    {
      this.list.append(cloneObjects.clone())
    }

    //画面内かどうかの判定
    this.isInView = false

    //スクロールのハンドリング
    $(window).scroll(this.onScroll.bind(this))
    this.onScroll()
  }

  onScroll()
  {
    const scrollY = $(window).scrollTop()
    const targetTop = this.list.offset().top - scrollY
    const targetBottom = targetTop + this.list.height()
    const winBottomY = $(window).innerHeight();
  
    this.isInView = (targetTop <= winBottomY && targetBottom >= 0)
  }

  update()
  {
    // return
    if(!this.isInView) return


    this.scrollX += this.scrollSpeed
    gsap.set(this.list, {
      x:(this.scrollX%this.scrollMax)
    })
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default Communicate
